import PvBadge from 'components/PvBadge.jsx';
import { updateApplicants } from 'ducks/drivingLessons';
import { getApplicantAction } from 'ducks/workItem';
import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import * as Table from 'reactabular-table';
import { Flex, Text } from 'rebass';
import { bindActionCreators, compose } from 'redux';
import * as sort from 'sortabular';
import { PvBox, PvCaret, PvLinkGreen, PvLinkGreenCap } from 'styles/CustomComponents';
import { resolve } from 'table-resolver';
import { arrayToCsv } from 'util/FormatUtil';
import { PvRadioButton } from '../form/PvRadioButton';

class DrivingApplicantsDataTable extends React.Component {
  constructor(props) {
    super(props);
    const getSortingColumns = () => this.state.sortingColumns || {};
    const updateApplicants = (applicants) => this.props.updateApplicants(applicants);

    const toggleSelection = (applicant) => {
      let applicants = this.props.rows;
      const i = applicants.map((a) => a.entityId).indexOf(applicant.entityId);
      // Set all applicant selections to false
      applicants.forEach((a) => {
        Object.assign(a, {selected: false})
      });
      const updatedApplicants = [
        ...applicants.slice(0, i),
        Object.assign(applicants[i], {selected: !applicants[i].selected}),
        ...applicants.slice(i + 1),
      ];
      this.props.setApplicantSelectedFn(true);
      updateApplicants(updatedApplicants);
    };

    const highlight = (lessons, type) => {
      const lessonsState = lessons.reduce((obj, key) => ({ ...obj, [key]: type}), {});
      this.props.highlightFn(lessonsState);
    };

    const sortable = sort.sort({
      getSortingColumns,
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumn({
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      },
      strategy: sort.strategies.byProperty
    });

    const columns = [
      {
        property: 'selected',
        header: {
          label: '',
        },
        props: {
          style: {
            width: '3em'
          }
        },
        cell: {
          formatters: [
            (value, props) => {
              return (
                <PvRadioButton defaultChecked={value} onChange={() => {
                  toggleSelection(props.rowData);
                }} />);
            }
          ],
          transforms: [
            (value, props) => {
              if (!props.rowData.hasOwnProperty('selected')) {
                Object.assign(props.rowData, {selected: false});
              }
            }
          ]
        }
      },
      {
        property: 'lastName',
        header: {
          label: <Flex alignItems='center' justifyContent='space-between'><Translate
            value='app.name' /><PvCaret /></Flex>,
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty
            })
          ]
        },
        cell: {
          formatters: [
            (value, props) => {
              return (
                <Text>
                  <PvLinkGreen href='#' onClick={(e) => {
                    e.preventDefault();
                    this.props.getApplicant(props.rowData.entityId);
                  }}>
                    {props.rowData.lastName}
                  </PvLinkGreen>
                  &nbsp;
                  <PvLinkGreenCap href='#' onClick={(e) => {
                    e.preventDefault();
                    this.props.getApplicant(props.rowData.entityId);
                  }}>
                    {props.rowData.firstNames}
                  </PvLinkGreenCap>
                </Text>
              );
            }
          ],
        }
      },
      {
        property: 'trafiId',
        header: {
          label: <Flex alignItems='center' justifyContent='space-between'><Translate
            value='app.trafi_id' /><PvCaret /></Flex>,
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty
            })
          ]
        }
      },
      {
        property: 'civilDrivingLicenses',
        header: {
          label: <Translate value='app.civil_driving_licenses' />
        },
        cell: {
          formatters: [
            (value, props) => {
              if (value && value.length > 0) {
                return arrayToCsv(value);
              } else {
                return '-';
              }
            }
          ]
        }
      },
      {
        header: {
          label: ''
        },
        cell: {
          formatters: [
            (value, props) => {
              return (
                <div>
                  {props.rowData.previousUndone.length > 0 &&
                  <PvBox
                    display='inline-block'
                    onMouseEnter={() => highlight(props.rowData.previousUndone, 'undone')}
                    onMouseLeave={() => highlight([])} >
                    <PvBadge type='PASSIVE' i18nMessage='app.previous_undone' />
                  </PvBox>
                  }
                  {props.rowData.previousComplete.length > 0 &&
                  <PvBox
                    display='inline-block'
                    onMouseEnter={() => highlight(props.rowData.previousComplete, 'complete')}
                    onMouseLeave={() => highlight([])} >
                    <PvBadge type='ACTIVE' i18nMessage='app.previous_complete' />
                  </PvBox>
                  }
                </div>
              );
            }
          ]
        }
      },
    ];

    this.state = {
      // Default sorting
      sortingColumns: {
        'lastName': {
          direction: 'asc',
          position: 0
        },
      },
      columns,
      rows: resolve({columns})(this.props.rows || [])
    };
  }

  componentWillReceiveProps(props) {
    this.setState({rows: props.rows});
  }

  render() {

    const {
      stylingRenderers,
      rowKey
    } = this.props;

    const {sortingColumns, columns, rows} = this.state;
    const finalRows = compose(
      sort.sorter({
        columns,
        sortingColumns,
        sort: orderBy,
        strategy: sort.strategies.byProperty
      }),
    )(rows);

    return (
      <Table.Provider
        renderers={stylingRenderers}
        columns={columns}>
        <Table.Header />
        <Table.Body rows={finalRows} rowKey={rowKey || 'entityId'} />
      </Table.Provider>
    );
  }
}

DrivingApplicantsDataTable.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  getApplicant: PropTypes.func,
  highlightFn: PropTypes.func,
  stylingRenderers: PropTypes.object,
  filters: PropTypes.object,
  rowKey: PropTypes.string,
  setApplicantSelectedFn: PropTypes.func,
  currentCourse: PropTypes.object,
};

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  updateApplicants: (applicants) => updateApplicants(applicants),
  getApplicant: (id) => getApplicantAction(id, ownProps.currentCourse),
}, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(DrivingApplicantsDataTable);


// WEBPACK FOOTER //
// ./src/components/datatable/DrivingApplicantsDataTable.jsx